<template>
  <!--专题详情 -->
  <div class="pcGuide">
      <img src="../images/pcguide.png" alt="">
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
export default {
  data () {
    return {
    }
  },
  created(){
  },
  mounted(){
  },
  methods:{
  }
}
</script>
<style lang="less" scoped>
.pcGuide{
    img{
        width: 100%;
    }
}
</style>





// WEBPACK FOOTER //
// src/pages/pcGuide.vue